// extracted by mini-css-extract-plugin
export default {"main":"nav_main__Y8o3g","logo":"nav_logo__HYxJ5"};